export const CONSOLE_MODELS = [
  { id: 'lyncia-o1-v1.0', label: 'Lyncia-o1 v1.0' },
  { id: 'lyncia-o1-v0.5', label: 'Lyncia-o1 v0.5' },
] as const;

export function consoleModelLabel(id: string, fallback = id): string {
  if (id === 'lyncia-counselor-r17-c4-step249') return 'Lyncia-o1 v1.0';
  if (id === 'lyncia-counselor-omni-r1' || id === 'lyncia-counselor-omni-r1-inline') return 'Lyncia-o1 v0.5';
  return CONSOLE_MODELS.find(model => model.id === id)?.label || fallback;
}

export function consoleModels(models: { id: string; label: string }[]) {
  const offered = models.map(model => model.id === 'lyncia-counselor-r17-c4-step249'
    ? { ...model, id: 'lyncia-o1-v1.0' } : model.id === 'lyncia-counselor-omni-r1-inline'
      ? { ...model, id: 'lyncia-o1-v0.5' } : model);
  const known = CONSOLE_MODELS.map(model => offered.find(item => item.id === model.id)
    || (model.id === 'lyncia-o1-v0.5' ? offered.find(item => item.id === 'lyncia-counselor-omni-r1') : undefined))
    .filter((model): model is { id: string; label: string } => Boolean(model));
  return known.map(model => ({ ...model, label: consoleModelLabel(model.id, model.label) }));
}
